import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeplerRoutingModule } from './kepler-routing.module';
import { KeplerNotificationListComponent } from './components/kepler-notification-list/kepler-notification-list.component';
import { KeplerPlayerListComponent } from './components/kepler-player-list/kepler-player-list.component';
import { KeplerEditorComponent } from './components/kepler-editor/kepler-editor.component';
import { KeplerMatchListComponent } from './components/kepler-match-list/kepler-match-list.component';
import { KeplerGoalListComponent } from './components/kepler-goal-list/kepler-goal-list.component';
import { KeplerProgressListComponent } from './components/kepler-progress-list/kepler-progress-list.component';
import { CoreModule } from 'core/core.module';
import { KeplerService } from './services/kepler.service';
import { KeplerPlayerEditorComponent } from './components/kepler-player-editor/kepler-player-editor.component';
import { KeplerDataQuestionsService } from './questions-service/kepler-data-questions.service';
import { EmailsModule } from '../emails/emails.module';
import { KeplerRankingListComponent } from './components/kepler-ranking-list/kepler-ranking-list.component';
import { KeplerGroupRankingListComponent } from './components/kepler-ranking-list/kepler-group-ranking/kepler-group-ranking.component';
import { KeplerFederationRankingListComponent } from './components/kepler-ranking-list/kepler-federation-ranking/kepler-federation-ranking.component';
import { KeplerPlayerProgressListComponent } from './components/kepler-player-list/kepler-player-progress-list/kepler-player-progress-list.component';
import { TranslationModalComponent } from './components/kepler-editor/translation-modal/translation-modal.component';
import { LeagueService } from 'core/services/league.service';

@NgModule({
  declarations: [
    KeplerMatchListComponent,
    KeplerEditorComponent,
    KeplerNotificationListComponent,
    KeplerPlayerListComponent,
    KeplerGoalListComponent,
    KeplerProgressListComponent,
    KeplerPlayerProgressListComponent,
    KeplerPlayerEditorComponent,
    KeplerRankingListComponent,
    KeplerGroupRankingListComponent,
    KeplerFederationRankingListComponent,
    TranslationModalComponent
  ],
  imports: [CommonModule, KeplerRoutingModule, CoreModule, EmailsModule],
  providers: [KeplerService, LeagueService, KeplerDataQuestionsService],
  exports: [
    KeplerMatchListComponent,
    KeplerGoalListComponent,
    KeplerPlayerListComponent,
    KeplerEditorComponent,
    KeplerNotificationListComponent,
    KeplerRankingListComponent,
    KeplerGroupRankingListComponent,
    KeplerFederationRankingListComponent,
    KeplerProgressListComponent,
    TranslationModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KeplerModule {}
